function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#FF8585"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.58 8.599l.3-.301a.112.112 0 00.028-.11.114.114 0 00-.084-.077l-1.298-.263a.111.111 0 00-.131.131l.262 1.299c.008.04.037.072.076.084.04.012.082 0 .111-.028l.3-.3.704.703a.11.11 0 00.157 0l.278-.278a.112.112 0 000-.157l-.704-.703z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.138 14.024l-.647-1.89a.458.458 0 00-.432-.311h-.099a.89.89 0 00.62-.848V4.893A.89.89 0 0014.695 4h-9.49a.89.89 0 00-.885.893v6.082a.89.89 0 00.62.848h-.098a.458.458 0 00-.432.31l-.648 1.891a1.15 1.15 0 00.148 1.035c.212.3.554.48.92.48h10.24c.366 0 .708-.18.92-.48.212-.3.267-.686.148-1.035zM9.95 4.206c.123 0 .224.101.224.226 0 .124-.1.225-.224.225a.225.225 0 01-.223-.225c0-.125.1-.226.223-.226zm-4.745.657l9.52.03v6.111l-9.55-.03.03-6.11zm6.466 9.8a.126.126 0 01-.104.057H8.334a.126.126 0 01-.105-.056.13.13 0 01-.012-.118l.312-.78a.415.415 0 01.384-.261h2.074c.169 0 .32.103.384.261l.312.78a.13.13 0 01-.012.118z"
})))));